import { Button, Skeleton, Text, HStack, VStack } from '@genial/components';
import { BoxBorder, BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Box } from 'native-base';

import { BlockedResource } from '../../../../constants';
import { ItemTag } from '../ItemTag';

interface cardItemMobileProps {
  blockedResource: BlockedResource;
  onRemoveBlock: (id: number) => void;
  isLoading: boolean;
}
export const CardItemMobile = ({
  blockedResource,
  onRemoveBlock,
  isLoading,
}: cardItemMobileProps) => {
  if (isLoading) {
    return (
      <Box
        borderBottomLeftRadius={BoxBorder.thick}
        borderTopLeftRadius={BoxBorder.thick}
        borderTopRightRadius={BoxBorder.heavy}
        borderBottomRightRadius={BoxBorder.heavy}
        backgroundColor={Color.background}
        px={Spacing['stack.xxs']}
        py={Spacing['stack.xxxs']}>
        <VStack justifyContent="space-between" space={Spacing['stack.nano']}>
          {Array.from({ length: 3 }).map((field, index) => (
            <HStack
              alignItems="center"
              justifyContent="space-between"
              space={Spacing['stack.quarck']}
              key={index}>
              <Skeleton
                height="15px"
                width="60px"
                borderRadius={BoxRadius.sm}
                endColor={Color['brand.primary.lightest']}
              />
              <Skeleton
                height="15px"
                width="60px"
                borderRadius={BoxRadius.sm}
                endColor={Color['brand.primary.lightest']}
              />
            </HStack>
          ))}

          <HStack justifyContent="flex-end" alignItems="center" pt={Spacing['stack.nano']}>
            <Skeleton
              height="15px"
              width="40px"
              borderRadius={BoxRadius.sm}
              endColor={Color['brand.primary.lightest']}
            />
          </HStack>
        </VStack>
      </Box>
    );
  }

  return (
    <Box
      borderBottomLeftRadius={BoxBorder.thick}
      borderTopLeftRadius={BoxBorder.thick}
      borderTopRightRadius={BoxBorder.heavy}
      borderBottomRightRadius={BoxBorder.heavy}
      backgroundColor={Color.background}
      px={Spacing['stack.xxs']}
      py={Spacing['stack.xxxs']}>
      <VStack justifyContent="space-between" space={Spacing['stack.nano']}>
        {blockedResource.item.map((field, index) => (
          <HStack
            alignItems="center"
            justifyContent="space-between"
            space={Spacing['stack.quarck']}
            key={index}>
            <Text fontSize={Typography['fontsize.md']} variant="regular" color="neutral.medium">
              {field.key}
            </Text>
            {Array.isArray(field.value) ? (
              <ItemTag data={field.value} />
            ) : (
              <Text fontSize={Typography['fontsize.md']} variant="regular" color="nuetral.black">
                {field.value}
              </Text>
            )}
          </HStack>
        ))}

        <HStack justifyContent="flex-end" alignItems="center" pt={Spacing['stack.nano']}>
          <Button
            variant="textLink"
            _text={{
              color: 'brand.tertiary.principal',
              fontWeight: 'semibold',
            }}
            isDisabled={!blockedResource.canDelete}
            onPress={() => onRemoveBlock(blockedResource.id)}>
            REMOVER
          </Button>
        </HStack>
      </VStack>
    </Box>
  );
};
